<template>
  <div
    v-if="hasConversationWithMessages"
    class="chat"
    :class="{ 'messages-customer': !productOwner }"
  >
    <div v-if="productOwner" class="ppl">
      <ChatConversations
        ref="ChatConversations"
        :conversations="localConversations"
        @pick="selectConversation"
      />
    </div>
    <div v-show="conversation" class="msgs">
      <div :class="['chat']">
        <div class="h" id="messages">
          <ChatMessage
            v-for="message in messages"
            :key="message.id"
            :message="message"
            :id="`message-${message.id}`"
          />
        </div>
        <div v-if="messages.length === 0" class="empty">
          Žádné zprávy
        </div>
      </div>
      <form action="#" class="type" @submit.prevent="sendMessage">
        <textarea
          v-model="input"
          type="text"
          id="chat-textarea"
          class="form-control mr-2"
          rows="3"
          placeholder="Vaše zpráva..."
          @keyup.enter="sendMessage"
        ></textarea>
        <button type="submit" class="btn btn-primary">
          <strong>Odeslat</strong>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage.vue'
import ChatConversations from './ChatConversations.vue'

export default {
  components: {
    ChatConversations,
    ChatMessage
  },
  props: {
    conversations: {
      type: Array,
      required: true
    },
    productOwner: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      localConversations: this.conversations.slice(),
      hasConversationWithMessages: false,
      conversation: null,
      page: 1,
      loading: false,
      messages: [],
      exclude: [],
      input: '',
      now: new Date(),
      axios: {
        CancelToken: null,
        source: null
      }
    }
  },
  async mounted() {
    if (this.productOwner && location.pathname.startsWith('/produkt/')) {
      const localConversations = this.localConversations.filter((c) => c.last_message)
      this.hasConversationWithMessages = localConversations.length > 0

      if (!this.hasConversationWithMessages) {
        $('.chat-section').remove()
        $('.site-blocks-2').addClass('bg-light')

        return
      } else {
        this.localConversations = localConversations
      }
    }

    this.hasConversationWithMessages = true

    $('#messages').scroll(async () => {
      if (this.messages.length === 0) return

      if ($('#messages').scrollTop() === 0) {
        const firstMessage = $('#messages div').get(0)

        await this.fetchMessages()

        this.scrollChat(firstMessage.offsetTop - 10)
      }
    })

    if (!this.productOwner && !window.conversation) {
      this.selectConversation(this.localConversations[0])

      this.gotoAnchor(true)
    }

    if (window.conversation) {
      const conversation = this.localConversations.filter((c) => c.id == window.conversation)

      if (conversation) {
        await this.$nextTick()

        if (this.productOwner) {
          this.$refs.ChatConversations.select(conversation[0])
        } else {
          this.selectConversation(conversation[0])
        }

        this.gotoAnchor()
      }
    }

    this.enablePusher()

    $(function() {
      const textarea = document.getElementById('chat-textarea')

      textarea.addEventListener('keydown', autosize)

      function autosize() {
        const el = this
        setTimeout(function() {
          el.style.cssText = 'height:auto; padding:7px'
          // for box-sizing other than "content-box" use:
          // el.style.cssText = '-moz-box-sizing:content-box';
          el.style.cssText = 'height:' + el.scrollHeight + 'px'

          if (!textarea.value) {
            el.style.cssText = 'height:' + 86 + 'px'
          }
        }, 100)
      }
    });
  },
  methods: {
    // select a conversation and reset everything from the old one
    selectConversation(conversation) {
      // cancel fetch messages request
      if (this.axios.source) {
        this.axios.source.cancel()
      }

      this.conversation = conversation
      this.messages = []
      this.exclude = []
      this.input = ''
      this.page = 1

      this.fetchMessages()
      this.markRead(conversation)
    },
    async fetchMessages() {
      // if page is equal to zero, stop sending requests for more messages
      if (this.page === 0) return

      this.axios.CancelToken = axios.CancelToken
      this.axios.source = this.axios.CancelToken.source()
      this.loading = true

      const messages = await axios
        .post(
          `/chat/messages?page=${this.page}`,
          {
            conversation: this.conversation.id,
            exclude: this.exclude
          },
          {
            cancelToken: this.axios.source.token
          }
        )
        .then((res) => res.data.data)

      this.messages = messages.reverse().concat(this.messages)

      if (this.page === 1) {
        // when messages are loaded for the first time, scroll to bottom
        this.scrollChat()
      }

      this.loading = false

      // if there is no more messages set the page to zero, else increase the page by one
      if (messages.length === 0) return (this.page = 0)
      else this.page++
    },
    async sendMessage(e) {
      const message = this.input.trim()
      if (!message || (e.keyCode === 13 && e.shiftKey)) return

      axios.post('/chat/messages/send', {
        conversation: this.conversation.id,
        body: message
      })

      // add message to the list
      this.messages.push({
        body: message,
        user_id: this.user.id,
        id: Math.random()
          .toString(36)
          .slice(2)
      })
      this.scrollChat()

      this.input = ''
    },
    // listen for a new messages
    enablePusher() {
      this.localConversations.forEach((conversation) => {
        Echo.join(`mc-chat-conversation.${conversation.id}`).listen('MessageWasSent', (e) => {
          if (this.conversation.id === conversation.id) {
            this.addMessage(e.message)
          }

          conversation.last_message = e.message
        })
      })
    },
    addMessage(message) {
      this.exclude.push(message.id)

      if (message.user_id !== this.user.id) {
        this.messages.push(message)
      }

      this.scrollChat()
      this.markRead(this.conversation)
    },
    markRead(conversation) {
      return axios.post('/chat/messages/read', {
        conversation: conversation.id
      })
    },
    async scrollChat(position) {
      await this.$nextTick()

      const messages = document.getElementById('messages')
      messages.scrollTop = position ? position : messages.scrollHeight
    },
    gotoAnchor(runCheck = false) {
      if (runCheck && !location.search.includes('anchor')) {
        return
      }

      setTimeout(() => {
        $('html, body').animate(
          {
            scrollTop: $('.chat').offset().top - 100
          },
          500
        )
      }, 500)
    }
  }
}
</script>
